module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26203",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6630",
      "conversations-error-reporting": "static-1.7911",
      "conversations-internal-pub-sub": "static-1.14991",
      "conversations-internal-schema": "static-1.11616",
      "conversations-message-history": "static-1.10081",
      "conversations-test-sdk": "static-1.9450",
      "conversations-visitor-experience-components": "static-1.19566",
      "head-dlb": "static-1.4130",
      "hs-promise-utils": "static-1.4520",
      "hs-test-utils": "static-1.6981",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10499",
      "I18n": "static-7.1398",
      "jasmine-immutable": "static-1.1944",
      "jasmine-runner": "static-1.5401",
      "quartz": "static-1.5738",
      "react-aria": "static-1.39",
      "react-dlb": "static-1.54",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3518",
      "viral-links-lib": "static-1.5861",
      "visitor-ui-component-library": "static-1.5171",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3543",
      "atom": "static-1.4140",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3781",
      "conversations-infrastructure": "static-1.7912",
      "conversations-prop-types": "static-1.6430",
      "conversations-visibility-tools": "static-1.4754",
      "conversations-visitor-message-history": "static-1.18303",
      "cssUtils": "static-1.527",
      "enviro": "static-4.310",
      "flux-actions": "static-1.278",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3063",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8459",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.288",
      "raven": "static-3.4958",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15545",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4463",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3357",
      "sanitize-text": "static-1.7142",
      "signup-constants": "static-1.16628",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.466",
      "usage-tracker": "static-1.6453",
      "usage-tracker-core": "static-1.6303",
      "usage-tracker-multi": "static-1.4867",
      "usage-tracker-public": "static-1.6264",
      "visitor-ui-component-library-icons": "static-1.4982",
      "hs-promise-rejection-tracking": "static-1.4492",
      "raven-hubspot": "static-1.5265",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2598",
      "moment": "static-3.26",
      "quartz-core": "static-1.4957",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.3888",
      "foundations-components": "static-1.6203",
      "foundations-theming": "static-1.3289",
      "UIComponents": "static-3.7446",
      "conversations-skeleton-state": "static-1.6354",
      "cv-backend-services": "static-1.1234",
      "icons": "static-2.592",
      "immutable-less": "static-1.3537",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.3713",
      "ui-images": "static-2.876",
      "permission-components": "static-1.4354",
      "react-virtualized": "static-2.74",
      "HeadJS": "static-2.583",
      "framer-motion": "static-1.41",
      "hs-test-utils-bend-plugin": "static-1.2092",
      "msw": "static-1.39",
      "testing-library": "static-1.121",
      "i18n-data": "static-1.199",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3327",
      "quartz-core-utils": "static-1.2605",
      "signup-ui-url-generator": "static-2.7034",
      "HubStyle": "static-2.10807",
      "sassPrefix": "static-1.132",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4870",
      "copilot-toolkit": "static-1.7173",
      "dispatcher": "static-1.114",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.656",
      "hub-http-shared-msw-handlers": "static-1.7281",
      "hubspotter-http": "static-1.3728",
      "hubspotter-http-shared-msw-handlers": "static-1.7279",
      "mobile-manifest-mixins": "static-1.354",
      "platform-navigation-bootstrap": "static-1.11411",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.332",
      "hs-story-utils": "static-1.8348",
      "bend-plugin-foundations-components": "static-1.2472",
      "floating-ui": "static-1.29",
      "foundations-theming-specialty": "static-1.1006",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1772",
      "foundations-theming-base": "static-1.2274",
      "ts-schema": "static-1.3263",
      "chatspot-client-types": "static-1.8891",
      "chatspot-core": "static-1.16514",
      "platform-infra-nav-components": "static-1.6836"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26203",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6630",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7911",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14991",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11616",
      "conversations-message-history": "/conversations-message-history/static-1.10081",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9450",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19566",
      "head-dlb": "/head-dlb/static-1.4130",
      "hs-promise-utils": "/hs-promise-utils/static-1.4520",
      "hs-test-utils": "/hs-test-utils/static-1.6981",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10499",
      "I18n": "/I18n/static-7.1398",
      "jasmine-immutable": "/jasmine-immutable/static-1.1944",
      "jasmine-runner": "/jasmine-runner/static-1.5401",
      "quartz": "/quartz/static-1.5738",
      "react-aria": "/react-aria/static-1.39",
      "react-dlb": "/react-dlb/static-1.54",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3518",
      "viral-links-lib": "/viral-links-lib/static-1.5861",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5171",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3543",
      "atom": "/atom/static-1.4140",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3781",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7912",
      "conversations-prop-types": "/conversations-prop-types/static-1.6430",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4754",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18303",
      "cssUtils": "/cssUtils/static-1.527",
      "enviro": "/enviro/static-4.310",
      "flux-actions": "/flux-actions/static-1.278",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8459",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.288",
      "raven": "/raven/static-3.4958",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15545",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4463",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3357",
      "sanitize-text": "/sanitize-text/static-1.7142",
      "signup-constants": "/signup-constants/static-1.16628",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.466",
      "usage-tracker": "/usage-tracker/static-1.6453",
      "usage-tracker-core": "/usage-tracker-core/static-1.6303",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4867",
      "usage-tracker-public": "/usage-tracker-public/static-1.6264",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4982",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4492",
      "raven-hubspot": "/raven-hubspot/static-1.5265",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2598",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4957",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.3888",
      "foundations-components": "/foundations-components/static-1.6203",
      "foundations-theming": "/foundations-theming/static-1.3289",
      "UIComponents": "/UIComponents/static-3.7446",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6354",
      "cv-backend-services": "/cv-backend-services/static-1.1234",
      "icons": "/icons/static-2.592",
      "immutable-less": "/immutable-less/static-1.3537",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.3713",
      "ui-images": "/ui-images/static-2.876",
      "permission-components": "/permission-components/static-1.4354",
      "react-virtualized": "/react-virtualized/static-2.74",
      "HeadJS": "/HeadJS/static-2.583",
      "framer-motion": "/framer-motion/static-1.41",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2092",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.121",
      "i18n-data": "/i18n-data/static-1.199",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3327",
      "quartz-core-utils": "/quartz-core-utils/static-1.2605",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7034",
      "HubStyle": "/HubStyle/static-2.10807",
      "sassPrefix": "/sassPrefix/static-1.132",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4870",
      "copilot-toolkit": "/copilot-toolkit/static-1.7173",
      "dispatcher": "/dispatcher/static-1.114",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.656",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7281",
      "hubspotter-http": "/hubspotter-http/static-1.3728",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7279",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.354",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11411",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.332",
      "hs-story-utils": "/hs-story-utils/static-1.8348",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2472",
      "floating-ui": "/floating-ui/static-1.29",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1006",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1772",
      "foundations-theming-base": "/foundations-theming-base/static-1.2274",
      "ts-schema": "/ts-schema/static-1.3263",
      "chatspot-client-types": "/chatspot-client-types/static-1.8891",
      "chatspot-core": "/chatspot-core/static-1.16514",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6836"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};